module.exports = __webpack_public_path__ + "img/scale.d358453e.svg";